/* eslint-disable @typescript-eslint/no-magic-numbers */
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TravelCost } from '../model/forms.model';

const SumCostValidator =
  (numberOfInsureds: number, resignationLimitPerInsuredPerson: number): ValidatorFn =>
  (formControl: AbstractControl): ValidationErrors | null => {
    const value = (formControl && (formControl.value as TravelCost[])) || null;

    const maxLimit = numberOfInsureds * resignationLimitPerInsuredPerson;
    const sum = value.map(({ travelCost }) => travelCost).reduce((acc: number, val: number | null) => (val ? acc + val : acc), 0);

    return sum > maxLimit ? { costExceeded: true } : null;
  };

export default SumCostValidator;
